import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Badge } from "primereact/badge";
import Operations from "../components/dashboard/Operations";
import { useAppContext } from "../providers/ProviderAppContainer";
import CarouselImages from "../components/dashboard/CarouselImages";
import ExamReminder from "../components/dashboard/ExamReminder";
import { TEXT_SMALL, TEXT_TITLE } from "../style";
import { APP_NAME } from "../constants";
import PromoDialog from "../components/common/PromoDialog";

export default function Dashboard() {
    const navigate = useNavigate();
    const { isDevelopmentBuild, deviceFingerPrint, requestAPI } = useAppContext();
    const pageConfig = useSelector((state) => state.stateTemplateConfig?.dash_board);
    const { id: userId, unseen_notification_count = 0 } = useSelector((state) => state.stateUser || {});
    const [promoDialogContents, setPromoDialogContents] = useState();

    useEffect(() => {
        requestAPI({
            requestPath: "dialog-contents/dashboard",
            requestMethod: "GET",
            onResponseReceieved: (contents, code) => {
                if (code === 200 && Array.isArray(contents)) {
                    setPromoDialogContents(contents);
                }
            },
        });
    }, [requestAPI]);

    const onContentSeen = useCallback(
        (content_id) => {
            requestAPI({
                requestPath: "dialog-contents/views/dashboard",
                requestMethod: "POST",
                requestPostBody: { content_id },
                parseResponseBody: false,
                onResponseReceieved: (_, code) => {
                    if (code === 204) {
                        setPromoDialogContents((prev) => prev?.filter((c) => c.id !== content_id) ?? []);
                    }
                },
            });
        },
        [requestAPI],
    );

    const whatsAppShareMessage = `Hey This is the Best Study Platform For All Subjects Best & Unique Education Features that must be experienced to for Excellent Knowledge & Result. I have already Registered in ${APP_NAME}. You should also Register Now From 👇🏼 www.sahasinstitute.com (Click & Register Free)`;

    return (
        <div className="flex flex-column h-full overflow-hidden">
            <div className="bg-primary shadow-3 flex align-items-center gap-3 p-2">
                <div className="w-8 flex-1">
                    <p className={`${TEXT_TITLE} m-0 font-semibold`}>Welcome To {APP_NAME}</p>
                    {isDevelopmentBuild && (
                        <div className={`${TEXT_SMALL} mt-1 white-space-nowrap text-overflow-ellipsis overflow-hidden opacity-90`}>
                            Device ID - {deviceFingerPrint}
                        </div>
                    )}
                </div>

                <div className="flex align-items-center gap-3 mr-2">
                    <i
                        className="pi pi-bell p-overlay-badge cursor-pointer"
                        style={{ fontSize: "1.5rem" }}
                        title="Notifications"
                        onClick={() => userId && navigate(`/manage-users/${userId}/notifications`)}
                    >
                        {Number(unseen_notification_count) > 0 && (
                            <Badge value={unseen_notification_count} severity="danger" />
                        )}
                    </i>
                    <i
                        className="pi pi-share-alt cursor-pointer"
                        style={{ fontSize: "1.5rem" }}
                        title="Share on WhatsApp"
                        onClick={() =>
                            window.open(`https://wa.me/?text=${encodeURIComponent(whatsAppShareMessage)}`, "_blank", "noopener,noreferrer")
                        }
                    />
                </div>
            </div>

            <ExamReminder className="mb-2" />
            <CarouselImages className={"mb-2"} images={pageConfig?.carousel_images} />
            <Operations className={"mx-2 mt-2 flex-1 min-h-0 overflow-scroll"} />

            <PromoDialog contents={promoDialogContents} onContentSeen={onContentSeen} />
        </div>
    );
}
